export const EItemsAction = {
  SET_ITEMS: 'SET_ITEMS',
  SET_SELECTED_ITEM: 'SET_SELECTED_ITEM',
  SET_EXTERNAL_ID_TYPES: 'SET_EXTERNAL_ID_TYPES',
  SET_PAGINATION: 'SET_PAGINATION_ITEMS',
  SET_SELECTED_UOM_ITEMS: 'SET_SELECTED_UOM_ITEMS',
  SET_SEARCH_PARAMS: 'SET_SEARCH_PARAMS',
};
